 (function($) {
    "use strict";
    $(function() {

        if($('#modal-general').length){
            var popupStart=moment($('#modal-general').data('start')).format("YYYY-MM-DD HH:mm:ss");
            var popupEnd=moment($('#modal-general').data('end')).format("YYYY-MM-DD HH:mm:ss");
            var currentdate = moment().format("YYYY-MM-DD HH:mm:ss"); 
            
       
            if(popupStart <= currentdate && currentdate<=popupEnd){
                $(".js-general-modal").iziModal({
                    history: false,
                    iframe: false,
                    fullscreen: false,
                    loop: false,
                    width: 800,
                    borderBottom: false,
                    radius: 0,
                    arrowKeys: false,
                    bodyOverflow: false,
                    navigateCaption: false,
                    zindex: 9999,
                    autoOpen:true
                });
            }
        
        }
 
        $(document).on('click', '.js-close-modal-general', function (e) {
            $('#modal-general').iziModal("close");
        });

    });
})(jQuery); 